import styled from 'styled-components';
import { EERIE, OBSIDIAN } from 'HubStyleTokens/colors';
import { getDisplayName, getId, isUserEditable } from 'find-and-filter-data/views-schema/public';
import NavViewLinkActions, { MenuButton } from './NavViewLinkActions';
import ViewCount from './ViewCount';
import UIButton from 'UIComponents/button/UIButton';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledButton = styled(props => /*#__PURE__*/_jsx(UIButton, Object.assign({}, props))).withConfig({
  displayName: "LinkWrapper__StyledButton",
  componentId: "sc-6ebpby-0"
})(["&&{width:100%;color:", ";font-weight:", ";padding-left:7px !important;padding-right:24px !important;border-right:0 !important;padding-top:8px;padding-bottom:8px;:hover{text-decoration:none;}}"], ({
  disabled
}) => disabled ? `${EERIE} !important;` : `${OBSIDIAN} !important`, ({
  selected
}) => selected ? '600' : '400');
const HoverWrapper = styled.div.withConfig({
  displayName: "LinkWrapper__HoverWrapper",
  componentId: "sc-6ebpby-1"
})(["position:relative;width:100%;overflow:hidden;:hover ", "{opacity:1;}:focus-within ", "{opacity:1;}"], MenuButton, MenuButton);
const LinkWrapper = ({
  disabled,
  view,
  viewId,
  handleViewMemberClick,
  buttonContent,
  actions,
  wrapperEl
}) => {
  const selected = viewId === getId(view);
  const viewIsEditable = isUserEditable(view) && !disabled && Boolean(actions.length);
  const onClickHandler = useCallback(() => handleViewMemberClick(disabled, selected, view), [handleViewMemberClick, disabled, selected, view]);
  const Wrapper = wrapperEl();
  return /*#__PURE__*/_jsx(HoverWrapper, {
    children: /*#__PURE__*/_jsxs(Wrapper, {
      selected: selected,
      "data-test-id": "view-wrapper",
      children: [/*#__PURE__*/_jsx(StyledButton, {
        disabled: disabled,
        selected: selected,
        "data-test-id": getDisplayName(view)
        /**
         * @deprecated - should replace usages with data-test-id attribute
         */,
        "data-selenium-view-name": getDisplayName(view),
        onClick: onClickHandler,
        use: "transparent",
        truncate: true,
        truncateStringProps: {
          className: 'justify-between',
          useFlex: true,
          fixedChildren: disabled ? null : /*#__PURE__*/_jsx(ViewCount, {
            view: view
          })
        },
        children: buttonContent || getDisplayName(view)
      }), viewIsEditable && /*#__PURE__*/_jsx(NavViewLinkActions, {
        actions: actions
      })]
    })
  });
};
LinkWrapper.displayName = 'LinkWrapper';
export default LinkWrapper;